
<div id="timeSlotDialogCard" class="control-card-white"> 

    <div class="control-card-header">
        {{ dialogTitle }}
        <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeGenericDialog()"></fa-icon>
    </div>

    <div class="control-card-content">

        <p class="margin-bottom-30"> 
            {{ dialogMessage }}
        </p>

    </div>

    <div class="control-card-buttons"> 
    
        <a (click)="firstButtonClick()" class="button">
            {{ dialogFirstButtonText }} <span><fa-icon icon="{{ dialogFirstButtonIcon }}"></fa-icon></span>
        </a>

        <a (click)="secondButtonClick()" class="button button-red float-right">
            {{ dialogSecondButtonText }} <span><fa-icon icon="{{ dialogSecondButtonIcon }}"></fa-icon></span>
        </a>
    
    </div>

</div>
        